<template lang="html">
  <div class="modal-wrapper">
    <div class="modal-close">
      <img
        @click="closeModal()"
        src="@/assets/icons/close.png"
        alt="close-modal-img"
      />
    </div>
    <div class="modal-title">
      {{ modalData.usr_name }}
    </div>
    <div class="card-wrapper">
      <div class="seller-card">
        <div v-for="(key, index) in dataToShow" :key="index">
          <div
            v-if="
              (userData[key] && key === 'usr_tax_info') ||
                (userData[key] && key === 'usr_business_register')
            "
            class="info"
          >
            <span class="info-key">{{ $t("details.seller." + key) }}:</span>
            <a target="_blank" :href="BaseURL + userData[key]">{{
              $t("main.fileWord")
            }}</a>
          </div>
          <template
            v-else-if="
              userData[key] &&
                key === 'socials' &&
                userData['socials'].length > 0
            "
          >
            <div v-for="soc in userData[key]" :key="soc.sct_name" class="info">
              <span class="info-key">{{ soc.sct_name }}:</span>
              <a target="_blank" :href="soc.link">
                <span class="info-value soc-name">{{ soc.link }}</span>
              </a>
            </div>
          </template>
          <div
            v-else-if="
              userData[key] && key !== 'socials' && key !== 'usr_rating'
            "
            class="info"
          >
            <span class="info-key">{{ $t("details.seller." + key) }}:</span>
            <span class="info-value">{{ userData[key] }}</span>
          </div>
        </div>

        <div class="info">
          <div style="width: 100%;" class="info-value">
            <input-view
              @keyup.enter="sendMsg()"
              type="textarea"
              :label="$t('details.seller.messageForBuyer')"
              max-length="300"
              v-model="message"
              rows="5"
            ></input-view>
          </div>
          <div v-if="message !== ''" @click="sendMsg()" class="dropdown-btn">
            <Icon icon="mdi:send"></Icon>
          </div>
        </div>
        <div v-if="contract" class="contract">
          <!-- <a v-if="!disableGetContractUrl"> -->
          <div class="btn dark-blue" @click="openConfirmationModal">
            {{ $t("main.downloadContract") }}
          </div>
          <!-- </a> -->
          <!-- <a v-else>
            <div class="btn dark-blue">
              <div class="spinner"></div>
            </div>
          </a> -->
          <questionmark :id="53" :toast="true" />
        </div>
      </div>
      <div class="seller-card right">
        <div class="inner-flex">
          <div class="info">
            <span class="info-key"
              >{{ $t("profile.purchase.purchaseTerms") }}:</span
            >
            <div class="info-value">
              {{ getTranslation(modalData.off_type) }}
            </div>
          </div>
          <div class="info">
            <span class="info-key"
              >{{ $t("profile.purchase.offeredPrice") }}:</span
            >
            <div class="info-value">
              {{
                modalData.prc_price
                  .toLocaleString("en")
                  .split(",")
                  .join(".")
              }}
              {{ modalData.cur_id }}
            </div>
          </div>
          <div class="info">
            <span class="info-key">{{ $t("profile.purchase.quantity") }}:</span>
            <div class="info-value">{{ modalData.off_quantity }}</div>
          </div>
          <!--  -->
          <div class="info" v-if="userData.usr_rating">
            <span class="info-key">{{ $t("profile.purchase.rate") }}:</span>
            <div class="info-value">
              <rating :rating="parseFloat(userData.usr_rating)" />
            </div>
          </div>
          <!--  -->
        </div>
        <div class="action-wrapper">
          <div class="info">
            <span class="info-key"
              >{{ $t("profile.purchase.buyerRating") }}:</span
            >
            <div class="info-value">
              <rate-user
                :rating="rate"
                @update-rating="
                  rate = $event;
                  fixRate();
                "
              />
            </div>
          </div>

          <div class="info">
            <div style="width: 100%;" class="info-value">
              <input-view
                type="textarea"
                max-length="300"
                :label="$t('profile.purchase.comment')"
                v-model="comment"
                rows="5"
              ></input-view>
            </div>
          </div>
          <div
            @click="rateUser(modalData.off_id)"
            class="btn dark-blue rate-btn"
          >
            {{ $t("profile.purchase.buyerRating") }}
          </div>
        </div>
        <!-- <div class="info">
          <span class="info-key">{{$t('details.seller.messageForSeller')}}:</span>
        </div>
        <input-view rows="5"></input-view> -->
      </div>
    </div>
  </div>
</template>

<script>
import Questionmark from "@/components/questionmark.vue";
import eventBus from "@/shared/eventBus.js";
import { api, baseURL } from "@/api";
import { mapState } from "vuex";
import rating from "@/components/rating.vue";
import TestInput from "@/components/shared/testInput.vue";
import { Icon } from "@iconify/vue2";
import RateUser from "@/components/shared/RateUser.vue";
export default {
  name: "buyerDetails",
  props: {
    modalData: {
      required: true
    }
  },
  components: {
    rating,
    Questionmark,
    InputView: TestInput,
    RateUser,
    Icon
  },
  data() {
    return {
      BaseURL: baseURL,
      dataToShow: [
        "usr_name",
        "usr_org_full_name",
        "usr_rating",
        "socials",
        "cnt_name",
        "usr_region",
        "usr_address",
        "usr_postal_code",
        "usr_phone_number",
        "usr_phone_number1",
        "usr_phone_number2",
        "usr_phone_number3",
        "usr_org_contact_person",
        "usr_org_contact",
        "osr_name",
        "otp_name",
        "usr_org_pib",
        "usr_org_id",
        "usr_org_registration_number",
        "usr_org_bank",
        "usr_org_services",
        "usr_business_register",
        "usr_tax_info"
      ],
      userData: {},
      rate: null,
      comment: null,
      message: "",
      contract: false,
      disableGetContractUrl: false
    };
  },
  mounted() {
    this.getUserInfo();
  },
  methods: {
    fixRate() {
      if (parseInt(this.rate) > 5) {
        this.rate = 5;
      } else if (parseInt(this.rate) < 1) {
        this.rate = 1;
      }
    },
    getUserInfo() {
      let params = {
        id: this.modalData.usr_id,
        off_id: this.modalData.off_id
      };
      api
        .getUserInfo(params)
        .then(res => {
          this.userData = res.data.data;
          if (res.data.hasOwnProperty("contract") && res.data.contract) {
            this.contract = res.data.hasOwnProperty("contract");
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    getContractUrl() {
      return "";
      const sid = localStorage.getItem("sid");
      return baseURL + `/offers/${this.modalData.off_id}/report?sid=${sid}`;
    },
    openConfirmationModal() {
      // getContractUrl
      let modalData = {
        off_id: this.modalData.off_id
      };
      let params = {
        modalData: modalData,
        component: "generateContract"
      };
      eventBus.$emit("openModal", params);
    },
    closeAndRefresh() {
      // this.disableGetContractUrl = true;
      // setTimeout(() => {
      // this.disableGetContractUrl = false;
      eventBus.$emit("refresh");
      eventBus.$emit("closeModal");
      // }, 2000);
    },
    closeModal() {
      eventBus.$emit("closeModal");
    },
    rateUser(id) {
      if (this.rate || this.comment) {
        let params = {
          id: id
        };
        if (this.rate) {
          params.rat_rating = this.rate;
        }
        if (this.comment) {
          params.rat_comment = this.comment;
        }
        api
          .rateUser(params)
          .then(res => {
            console.log(res);
            this.$toast.success(this.$t("main.rateSuccess"), {
              duration: 8000
            });
          })
          .catch(e => {
            console.log(e);
            this.$toast.error(this.$t("main.rateError"), {
              duration: 8000
            });
          })
          .finally(() => {
            this.rate = null;
            this.comment = null;
          });
      } else {
        this.$toast.error(this.$t("main.rateError"), {
          duration: 8000
        });
      }
    },
    sendMsg() {
      if (this.message !== "") {
        let params = {
          msg_message: this.message,
          usr_id_to: this.userData.usr_id
        };
        this.connection.send(JSON.stringify(params));
        this.$toast.success(this.$t("main.msgSuccess"), {
          duration: 8000
        });
        this.message = "";
      } else {
        this.$toast.error(this.$t("main.msgError"), {
          duration: 8000
        });
      }
    }
  },
  computed: {
    ...mapState(["connection"]),
    getTranslation() {
      return condition => {
        if (condition === 1) {
          return this.$t("dropdown.condition1");
        } else {
          return this.$t("dropdown.condition2");
        }
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-wrapper {
  width: 800px;
  max-width: 80%;
  max-height: 70vh;
  overflow: auto !important;

  @import "@/assets/scss/scrollbarStyles.scss";
  @include scrollbar;
  @import "@/assets/scss/cardStyles.scss";
  @import "@/assets/scss/btnStyles.scss";

  .dropdown-btn {
    cursor: pointer;
    width: 35px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid $blue-400;
    border-radius: 3px;
    margin-left: auto;
    margin-top: 10px;
  }

  .card-wrapper {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    .seller-card {
      width: calc(50% - 20px);
      margin-bottom: 0px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      gap: 2px;
      .inner-flex {
        display: flex;
        flex-direction: column;

        gap: 2px;
      }
      .rate-btn {
        margin-top: 22px;
      }
    }
    .contract {
      display: flex;
      margin-top: 10px;
      width: 100%;
      align-items: center;
      span {
        margin-top: -6px;
      }
      a {
        flex-grow: 1;
        text-decoration: none !important;
      }
    }
  }
  .modal-title {
    font-weight: bold;
    font-size: 21px;
    line-height: 34px;
    letter-spacing: 0.06em;
    text-align: left;
    margin-bottom: 10px;
  }
  .modal-close {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;

    img {
      cursor: pointer;
    }
  }
  @media only screen and (max-width: 768px) {
    .seller-card {
      width: 100% !important;
      margin-bottom: 20px !important;
    }
  }
  .info-key {
    white-space: normal !important;
  }
}
a {
  .info-value.soc-name {
    word-break: break-all;
  }
}
</style>
